import React, { PureComponent } from 'react';
import {
	BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';

import CreateReactClass from 'create-react-class';

import { StyledBiaxialBarChart } from './style/StyledBiaxialBarChart';

import { SelectColor, Translate } from '../../../../services/reports';

const CustomTooltip = ({ payload, active, channel }) => {
	if (active) {
		return (
			<div className="custom-tooltip">
				<strong className="label m-0">{payload[0].payload.name}</strong>
				<p className={`label m-0 label-clicks element-${channel}`}>{`${payload[0].name}: ${(payload[0].payload.clicks).toLocaleString('pt-BR')}`}</p>
				<p className={`label m-0 label-impressions element-${channel}`}>{`${payload[1].name}: ${(payload[0].payload.impressions).toLocaleString('pt-BR')}`}</p>
			</div>
		);
	}

	return null;
};

const CustomizedAxisTick = CreateReactClass({
	render() {
		const { x, y, payload } = this.props;

		return (
			<g transform={`translate(${x},${y})`}>
				<text x={0} y={0} dy={5} textAnchor="end" fill="#666">{payload.value}</text>
			</g>
		);
	},
});

export default class Example extends PureComponent {
	render() {
		const { data, typeChart, channel } = this.props;

		return (
			<StyledBiaxialBarChart className={`simple-bar-chart ${typeChart === 'CampaignRange' ? 'campaign-range' : 'bar-chart'}`}>
				<div style={{ width: '100%', height: 600 }}>
					<ResponsiveContainer width="100%" debounce={1}>
						<BarChart
							data={data}
							layout="vertical"
							margin={{
								top: 5, right: 30, left: 20, bottom: 5,
							}}
							width="100%"
						>
							<YAxis type="category" dataKey="name" tick={<CustomizedAxisTick />} />
							<XAxis xAxisId="top" orientation="top" type="number" dataKey="clicks" />
							<XAxis xAxisId="bottom" orientation="bottom" type="number" dataKey="impressions" />
							<CartesianGrid strokeDasharray="3 3" width="100%" />
							<Tooltip content={<CustomTooltip channel={channel} />} />
							<Bar barSize={20} xAxisId="top" dataKey="clicks" name={Translate('clicks')} fill={SelectColor(channel, 'clicks')} />
							<Bar barSize={20} xAxisId="bottom" dataKey="impressions" name={Translate('impressions')} fill={SelectColor(channel, 'impressions')} />
						</BarChart>
					</ResponsiveContainer>
				</div>
			</StyledBiaxialBarChart>
		);
	}
}
